import { ViewLayoutListColumns } from '@/types/view.types';

export enum ROUTES {
  ROOT = '/',
  DNE = '/doesNotExist',
  PERSONNEL = '/personnel',
  UNAUTHORIZED = '/unauthorized',
  VIEWS = '/views',
  EDIT = '/edit',
}

export const LAYOUT_LIST_PUBLIC_ONLY_COLUMNS = [
  ViewLayoutListColumns.ASSIGNMENT,
  ViewLayoutListColumns.ASSIGNMENT_UNITS,
  ViewLayoutListColumns.DATE,
  ViewLayoutListColumns.LOCATIONS,
  ViewLayoutListColumns.PERSONNEL,
  ViewLayoutListColumns.START_TIME,
  ViewLayoutListColumns.STOP_TIME,
  ViewLayoutListColumns.TEMPLATE,
];

// You MUST use camel-case for key names, even if the key is not camel-cased in LaunchDarkly!!!!!!!!
export enum FEATURE_FLAGS_ENUM {
  LV10019ListViewSorting = 'lv10019ListViewSorting',
  LV15455NVMNoDepartmentMRC = 'lv15455NvmNoDepartmentMrc',
  LV14088ModifyColumnHeaders = 'lv14088ModifyColumnHeaders',
  LV14123DailyListViewHideSections = 'lv14123DailyListViewHideSections',
}

export const UI = {
  oddRowColor: '#edf2f7',
};
